if (!navigator.permissions.query) {
  navigator.permissions.query = async function (query: { name: string }) {
    //always return denied if this does not exist
    return Promise.resolve<PermissionStatus>({
      name: query.name,
      state: 'denied',
    } as unknown as PermissionStatus)
  }
}
